import { createContext } from 'react';
import { ContextWrapper } from '../../config/constants';
import { TransactionActions, TransactionStateType } from './transactionTypes';

const transactionContext = createContext(
    {} as ContextWrapper<TransactionStateType, TransactionActions>
);
transactionContext.displayName = 'TransactionContext';

export default transactionContext;
